import { FC } from 'react';
import { withStyles } from 'vopay';
import styles from './CreateContactPage.module.scss';
import CreateCustomerForm from '@/components/Customer/CreateCustomer/CreateCustomerForm';
import { useTranslation } from 'react-i18next';
import { UtilButton, Title } from 'UI';
import { useHistory, useLocation } from 'react-router-dom';
import useContacts from '@/hooks/useApi/useContacts';
import { SerializedFormValues } from '@/components/Customer/CreateCustomer/useFormConfig';

type LocationState = {
  showBackButton?: boolean;
};

const cn = withStyles(styles);

const CreateContactPage: FC = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { state } = location;
  const { t } = useTranslation('translations', { keyPrefix: 'Customers.Create' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { createContact } = useContacts();

  async function handleCreateContact(values: SerializedFormValues) {
    const { contactID } = await createContact({
      FirstName: values.firstName,
      LastName: values.lastName,
      EmailAddress: values.email,
      PhoneNumber: values.phone,
      BusinessName: values.businessName,
      ContactID: values.accountID,
      Label: values.label,
      Address1: values.address1,
      City: values.city,
      Province: values.province,
      PostalCode: values.postalCode,
      Country: values.country,
      FlinksAccountID: values.flinksAccountID,
      FlinksLoginID: values.flinksLoginID,
      PlaidProcessorToken: values.plaidProcessorToken,
    });

    return contactID;
  }

  const showBackButton = state?.showBackButton;

  return (
    <div className={cn('createContactPage')}>
      {showBackButton && (
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/contacts');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : t('contactTitle')}
        </UtilButton>
      )}
      <Title className={cn('title')}>{t('pageTitle', { label: t('contact') })}</Title>

      <div className={cn('form')}>
        <CreateCustomerForm
          customerLabel={t('contact')}
          createAccount={handleCreateContact}
          onComplete={(accountID, search) => {
            history.replace({
              pathname: `/contacts/${accountID}`,
              search: search ? new URLSearchParams(search).toString() : undefined,
            });
          }}
        />
      </div>
    </div>
  );
};

export default CreateContactPage;
